export default __webpack_public_path__ + "static/media/aa_mag_2_lg.fecb134f.jpg";